<script setup>
import { DxButton } from 'devextreme-vue/button'
import { useDialog } from '@/composables/dialog'
import { getI18n } from '@/plugins/i18n'

const props = defineProps({
  grid: Object,
  visible: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  onReset: {
    type: Function,
    required: true,
  },
})

const i18n = getI18n()
const { genericDialog } = useDialog()

const onClick = async() => {
  genericDialog(
    i18n.t('common.reset'),
    i18n.t('common.resetDocumentStatusColor'),
    { cancel: true, persistent: true }
  ).onOk(async() => {
    await props.onReset(props.selectedRowsId).then(res => {
      props.grid?.instance.refresh()
    })
  })
}
</script>

<template>
  <slot>
    <dx-button
      icon="mdi mdi-restore"
      :hint="i18n.t('common.reset')"
      styling-mode="text"
      :visible="props.visible"
      :disabled="props.disabled"
      type="normal"
      @click="onClick"
    />
  </slot>
</template>
